import { create } from 'zustand';

const useSettingsStore = create((set) => ({
    blurPII: JSON.parse(localStorage.getItem('blurPII') || 'false'),

    toggleBlurPII: () => set((state) => {
        const next = !state.blurPII;
        localStorage.setItem('blurPII', JSON.stringify(next));
        return { blurPII: next };
    }),

    showSettingsModal: false,
    openSettings: () => set({ showSettingsModal: true }),
    closeSettings: () => set({ showSettingsModal: false }),
}));

export default useSettingsStore;
